export let CalendarProvider = /*#__PURE__*/function (CalendarProvider) {
  CalendarProvider["GOOGLE"] = "GOOGLE";
  CalendarProvider["MICROSOFT"] = "MICROSOFT";
  CalendarProvider["ICLOUD"] = "ICLOUD";
  return CalendarProvider;
}({});
//# sourceMappingURL=CalendarProvider.js.map